import { combineReducers } from 'redux';
// App-level ducks
import hostedAssets from './hostedAssets.duck';
import paymentMethods from './paymentMethods.duck';
import marketplaceData from './marketplaceData.duck';
import ui from './ui.duck';
import auth from './auth.duck';
import emailVerification from './emailVerification.duck';
import user from './user.duck';
import routing from './routing.duck';
// Container-level ducks
import SearchPage from '../containers/SearchPage/SearchPage.duck';
import ProfilePage from '../containers/ProfilePage/ProfilePage.duck';
import LandingPage from '../containers/LandingPage/LandingPage.duck';
import CMSPage from '../containers/CMSPage/CMSPage.duck';
import ContactDetailsPage from '../containers/ContactDetailsPage/ContactDetailsPage.duck';
import PasswordChangePage from '../containers/PasswordChangePage/PasswordChangePage.duck';
import ManageListingsPage from '../containers/ManageListingsPage/ManageListingsPage.duck';
import PasswordRecoveryPage from '../containers/PasswordRecoveryPage/PasswordRecoveryPage.duck';
import PrivacyPolicyPage from '../containers/PrivacyPolicyPage/PrivacyPolicyPage.duck';
import TransactionPage from '../containers/TransactionPage/TransactionPage.duck';
import EmailVerificationPage from '../containers/EmailVerificationPage/EmailVerificationPage.duck';
import AuthenticationPage from '../containers/AuthenticationPage/AuthenticationPage.duck';
import PasswordResetPage from '../containers/PasswordResetPage/PasswordResetPage.duck';
import TermsOfServicePage from '../containers/TermsOfServicePage/TermsOfServicePage.duck';
import EditListingPage from '../containers/EditListingPage/EditListingPage.duck';
import ListingPage from '../containers/ListingPage/ListingPage.duck';
import InboxPage from '../containers/InboxPage/InboxPage.duck';
import CheckoutPage from '../containers/CheckoutPage/CheckoutPage.duck';

const rootDuckReducer = combineReducers({
  hostedAssets,
  paymentMethods,
  marketplaceData,
  ui,
  auth,
  emailVerification,
  user,
  routing,
  SearchPage,
  ProfilePage,
  LandingPage,
  CMSPage,
  ContactDetailsPage,
  PasswordChangePage,
  ManageListingsPage,
  PasswordRecoveryPage,
  PrivacyPolicyPage,
  TransactionPage,
  EmailVerificationPage,
  AuthenticationPage,
  PasswordResetPage,
  TermsOfServicePage,
  EditListingPage,
  ListingPage,
  InboxPage,
  CheckoutPage,
});

export default rootDuckReducer;
